<template>
	<div class="group-approval-ratings-container">
		<div class="range-slider-wrapper">
			<div class="range-slider-wrapper-label-left">{{ min }}</div>
			<div class="range-slider-wrapper-interactive">
				<!-- @vue-expect-error -->
				<percent-from-center-bar
					:value="averageApprovalRating"
					:min="min"
					:max="max"
				></percent-from-center-bar>
			</div>
			<div class="range-slider-wrapper-label-right">{{ max }}</div>
		</div>
		<rainbow-range-value-box
			:min="min"
			:max="max"
			:value="averageApprovalRating"
		></rainbow-range-value-box>
	</div>
</template>

<script>
// Other components
import PercentFromCenterBar from "./graphs_and_visualizations/percent_from_center_bar.vue";

export default {
	// Naming - server = srv
	props: {
		srvApprovalRatings: Array,
		min: Number,
		max: Number,
		isIndividualRating: {
			type: Boolean,
			default: false,
		},
		groupId: Number,
		approvalColors: {
			type: Array,
			default: function () {
				return [
					"#BB0000",
					"#BB2900",
					"#BB5300",
					"#BB7C00",
					"#BBA600",
					"#A6BB00",
					"#7CBB00",
					"#53BB00",
					"#29BB00",
					"#00BB00",
				];
			},
		},
	},
	components: {
		"percent-from-center-bar": PercentFromCenterBar,
	},
	data: function () {
		return { approval_ratings: this.srvApprovalRatings };
	},
	computed: {
		averageApprovalRating() {
			var sum = _.reduce(
				_.clone(this.approval_ratings),
				function (sum, ar) {
					return ar.rating + sum;
				},
				0,
			);
			if (this.approval_ratings.length > 0) {
				return Math.round((sum / this.approval_ratings.length) * 10) / 10;
			}
			return 0;
		},
	},
	mounted() {
		pp.vue.bus.$on("approval_rating-CREATE", (ar) => {
			this.handleIncoming(ar);
		});
	},
	beforeDestroy() {
		pp.vue.bus.$off("approval_rating-CREATE");
	},
	methods: {
		handleIncoming(payload) {
			if (
				payload.actor &&
				payload.actor.principal_group.id === this.principalGroupId
			) {
				var idx = _.findIndex(this.approval_ratings, (ar) => {
					return ar.actor_id === payload.actor_id;
				});
				// Replace the approval_rating property at the id or create a new obj if !exists
				if (idx !== -1) {
					this.approval_ratings[idx].rating = payload.rating;
				} else if (!this.isIndividualRating) {
					this.approval_ratings.push(payload);
				}
			}
		},
	},
};
</script>
